import Header from "./components/Header";
import Hero from "./components/Hero";
import TrendBoard from "./components/TrendBoard";
import QuickFeed from "./components/QuickFeed";
import TimelineFeature from "./components/TimelineFeature";
import TopicWall from "./components/TopicWall";
import AnalysisGrid from "./components/AnalysisGrid";
import ReplayFeature from "./components/ReplayFeature";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <span id="top" className="sr-only" aria-hidden="true"></span>
      <Header />
      <main>
        <Hero />
        <TrendBoard />
        <QuickFeed />
        <TimelineFeature />
        <TopicWall />
        <AnalysisGrid />
        <ReplayFeature />
      </main>
      <Footer />
    </div>
  );
}